import { useCallback, useEffect, useState } from 'react';
import { useGlobals } from 'src/shared/contexts/appContext';
import { getAllAutogiroMandate } from 'src/shared/services/autogiroMandateService';
import { AutogiroMandateStatusEnum } from 'src/shared/models/enums/autogiroMandateStatus.enum';

/**
 * Antal månadsgivare där dragningen inte blir av: medgivandet är ej godkänt, har fel eller är
 * makulerat. Antalet kommer från medgivandelistan med pageSize 1, så bara totalen hämtas hem.
 */
export const useDonorActionRequiredBadge = (enabled = true): [number, () => void] => {
  const { dateStamp } = useGlobals();
  const [count, setCount] = useState(0);

  const fetch = useCallback(() => {
    if (!enabled) return;

    getAllAutogiroMandate({
      pageIndex: 0,
      pageSize: 1,
      sortCol: 'autogiroMandate_id',
      sortDir: 'desc',
      filter: '',
      linkedFilter: 'donor',
      status: [AutogiroMandateStatusEnum.NotApproved, AutogiroMandateStatusEnum.Canceled, AutogiroMandateStatusEnum.Error],
    })
      .then((res) => setCount(res.data.totalItems ?? 0))
      .catch(() => undefined);
  }, [enabled]);

  useEffect(() => {
    fetch();
  }, [fetch, dateStamp]);

  return [count, fetch];
};
